import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }

import { computed, ref } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ReadMoreText',
  props: {
  text: {
    type: String,
    required: true,
  },
  concat: {
    type: Number,
    default: 70,
  },
  initialOpen: {
    type: Boolean,
    default: false,
  },
},
  emits: ["toggleOpenEmit"],
  setup(__props, { emit: __emit }) {

const toggleOpen = () => {
  isOpen.value = !isOpen.value;
  emit("toggleOpenEmit", isOpen.value);
};
const props = __props;
const emit = __emit;
const isOpen = ref(props.initialOpen);
const isTextLong = computed(() => props.text.length > props.concat);

const shorterText = computed(() => {
  return props.text.slice(0, props.concat) + "...";
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", null, [
    (!isOpen.value && isTextLong.value)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
          _createTextVNode(_toDisplayString(shorterText.value) + " ", 1),
          _createElementVNode("span", {
            role: "button",
            tabindex: "0",
            onClick: toggleOpen,
            class: "text-decoration-underline"
          }, " Read More")
        ]))
      : _createCommentVNode("", true),
    (isOpen.value && isTextLong.value)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
          _createTextVNode(_toDisplayString(props.text) + " ", 1),
          _createElementVNode("span", {
            tabindex: "0",
            role: "button",
            class: "text-decoration-underline",
            onClick: toggleOpen
          }, " Read Less ")
        ]))
      : _createCommentVNode("", true),
    (!isTextLong.value)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(props.text), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})